export const API_ERROR_TOAST_EVENT = "reports:api-error-toast";

const CANDIDATE_KEYS = [
  "message",
  "error",
  "detail",
  "title",
  "description",
  "reason",
  "msg",
];

const normalizeValue = (value) => {
  if (value === null || value === undefined) return "";
  if (typeof value === "string") return value.trim();
  if (typeof value === "number" || typeof value === "boolean") return String(value);

  return "";
};

const extractFromObject = (payload) => {
  if (!payload || typeof payload !== "object") return "";

  for (const key of CANDIDATE_KEYS) {
    const value = normalizeValue(payload[key]);

    if (value) {
      return value;
    }
  }

  if (Array.isArray(payload.errors)) {
    const arrayMessage = payload.errors.map(normalizeValue).find(Boolean);

    if (arrayMessage) {
      return arrayMessage;
    }
  }

  if (payload.errors && typeof payload.errors === "object") {
    const nestedMessage = Object.values(payload.errors)
      .flatMap((value) => (Array.isArray(value) ? value : [value]))
      .map(normalizeValue)
      .find(Boolean);

    if (nestedMessage) {
      return nestedMessage;
    }
  }

  return "";
};

export const parseApiError = (error, fallbackMessage = "Unexpected API error") => {
  const data = error?.response?.data;
  const status = error?.response?.status;
  const statusText = normalizeValue(error?.response?.statusText);

  const messageFromData =
    normalizeValue(data) ||
    extractFromObject(data) ||
    normalizeValue(error?.message) ||
    fallbackMessage;

  const details =
    extractFromObject(data?.details) ||
    extractFromObject(data) ||
    normalizeValue(data?.traceId) ||
    "";

  const message = status ? `[${status}${statusText ? ` ${statusText}` : ""}] ${messageFromData}` : messageFromData;

  return {
    message,
    details,
    status,
  };
};

export const emitApiErrorToast = (error, fallbackMessage) => {
  if (typeof window === "undefined") return;

  const payload = parseApiError(error, fallbackMessage);

  window.dispatchEvent(new CustomEvent(API_ERROR_TOAST_EVENT, { detail: payload }));
};